export default {
  enterprisePlan: {
    hi: 'general.hi',
    freeTrial: 'enterprisePlan.freeTrial',
    desc: 'enterprisePlan.desc',
    contactUs: 'enterprisePlan.contactUs',
    email: 'enterprisePlan.email',
    mail: 'enterprisePlan.mail',
    street: 'enterprisePlan.street',
    city: 'enterprisePlan.city',
    chat: 'enterprisePlan.chat',
    description: 'enterprisePlan.description',
    loading: 'enterprisePlan.loading',
  },
};
